import {
  LoadPagedCustomFieldsRequest,
} from 'app/models/api/custom-fields';
import { Order } from 'app/models/order';
import { PaginationOptions } from 'app/models/pagination-options';
import { SelectableItem } from '../../models/reducers/meta-data';

export class CustomFieldsEffectsUtils {
  static buildBasePagedRequestPayload(order: Order, selectedCategories: SelectableItem, paginationOptions: PaginationOptions): LoadPagedCustomFieldsRequest {
    const categoryIds: string[] = Object.keys(selectedCategories) || [];
    return {
      orderBy: order?.orderBy || 'label',
      count: paginationOptions?.count || 50,
      offset: paginationOptions?.page > 1 ? (paginationOptions.page - 1) * paginationOptions.count : 0,
      orderDirection: order?.ascending ? 'asc' : 'desc',
      categoryIds,
    };
  }
}
